import { connect } from "react-redux";
import BookingAside from "./BookingAside.jsx";
import { matchPath } from "react-router-dom";
import get from "lodash/get";
import { shouldEnableFlexRateChoice } from "app/pages/Booking/Quotation/quotationSelectors";

const mapStateToProps = (state, props) => {
	const currentPathname = props.location.pathname;

	const isQuote = matchPath(currentPathname, {
		path: "/booking/quote",
	});

	const isSDPQuote = matchPath(currentPathname, {
		path: "/sdp/booking/quote",
	});

	const isPaymentPage = matchPath(currentPathname, {
		path: "/booking/payment",
	});

	const isSDPPaymentPage = matchPath(currentPathname, {
		path: "/sdp/booking/payment",
	});

	const isSDPConfirmationPage = matchPath(currentPathname, {
		path: "/sdp/booking/confirmation",
	});

	const isConfirmationPage = matchPath(currentPathname, {
		path: "/booking/confirmation",
	});

	const isSearchPage = matchPath(currentPathname, {
		path: "/booking/search",
	});

	return {
		isQuotationPage: isSDPQuote || isQuote,
		showPriceDetails: !isSearchPage && get(state, "quotation.quotationItems.length") > 0,
		shop: state.shop,
		showProductPicture: !isSDPQuote,
		quotation: state.quotation,
		ficheProduit: state.ficheProduit,
		showPaymentTerms: !isSDPConfirmationPage && !isConfirmationPage,
		isPaymentPage: isPaymentPage || isSDPPaymentPage,
		showContactUs: !isSDPConfirmationPage && !isConfirmationPage,
		enableFlexRateChoice: shouldEnableFlexRateChoice(state),
	};
};

export default connect(mapStateToProps)(BookingAside);
